import { Box } from '@mui/material';
import React, { ReactNode } from 'react';
import { SmallProgressChart, SmallProgressChartProps } from './SmallProgressChart.component';
import { ProgressChartHeader, ProgressChartHeaderProps } from './ProgressChartHeader.component';


export type ProgressChartProps = {
  title: ProgressChartHeaderProps['title'];
  isDisabled?: boolean;
  customTitleValue?: ReactNode;
  maxScore?: number | null;
  data: SmallProgressChartProps['data'];
  summary?: {
    score: number;
    scoreDiffPercentage?: number;
  };
  fillUpTo?: SmallProgressChartProps['fillUpTo'];
  onDetails?: ProgressChartHeaderProps['onDetails'];
};


export const ProgressChart: React.FC<ProgressChartProps> = (props) => {

  return (
    <Box display="flex" flexDirection="column">
      <ProgressChartHeader
        title={props.title}
        disabled={props.isDisabled}
        customTitleValue={props.customTitleValue}
        onDetails={props.onDetails}
        difference={props.summary?.scoreDiffPercentage}
        value={props.summary?.score ?? '–'}
      />
      {props.data?.length > 1 ? (
        <Box mb={3}>
          <SmallProgressChart
            data={props.data}
            fillUpTo={props.fillUpTo}
            maxScore={props?.maxScore}
          />
        </Box>
      ) : null}
    </Box>
  );
};
